import { BookAppointmentProvider } from '@/components/modules/modals/BookAppointment/BookAppointment.hooks';
import SearchResultsPage from '@/features/searchV2/pages';
import { SearchManagerProps, SearchProvider } from '@/hooks/search/useSearch';
import { SearchStateCacheProvider } from '@/hooks/search/useSearchStateCache';

const SearchPage = ({ type = 'default' }: SearchManagerProps) => {
  return (
    <SearchStateCacheProvider>
      <SearchProvider type={type}>
        <BookAppointmentProvider>
          <SearchResultsPage />
        </BookAppointmentProvider>
      </SearchProvider>
    </SearchStateCacheProvider>
  );
};

export default SearchPage;
